module.exports = __webpack_public_path__ + "static/media/x.55426f4f.svg";